/**
* Site navigation. 
* Desktop mega menu and mobile navigation which uses - http://mmenu.frebsite.nl/
*/

import $ from 'jquery';
require('jquery.mmenu');
require('../plugins/jquery.hoverIntent');

import { close as closeSearch } from './searchBar';

let navIsOpen = false;
let mmenuApi;

// Cached elements
const $el = {
	nav: $('#js-nav'),
	navToggle: $('.js-nav-toggle'),
	searchBarToggle: $('.js-search-bar-toggle'),
	subnavTrigger: $('.has-subnav'),
	subnavContent: $('.c-nav-content')
};

const hoverIntentConfig = {
    sensitivity: 3,
    interval: 55,
    timeout: 300,
    over: menuOn,
    out: menuOff
};

// Module events
export default function init() {
	
	const titleText = $('.c-top-nav__inner ul:first .is-active a').text();
	
	mmenuApi = $el.nav.mmenu({
		// options
		navbar: {
			title: titleText
		},
		offCanvas: {
			pageSelector: '#page',
			zposition: 'front',
			position: 'right'
		},
		counters: true
	}, {
		// configuration
		clone: true
	}).data('mmenu');
	
	bindEvents();
	
	// Make the title go to the homepage
	$('#mm-0 .mm-navbar .mm-title').attr('href', '/');
}

// User interactions go here
function bindEvents() {
	// Bind show/hide function
	$el.navToggle.on('click', function() {
		const $this = $(this);
		
		if (navIsOpen) {
			close();
		} else {
			open();
		}
	});
	
	$el.searchBarToggle.on('click', function() {
		if (navIsOpen) {
			mmenuApi.close();
			$el.navToggle.removeClass('is-active');
			navIsOpen = false;
		}
	});

	$el.subnavTrigger.hoverIntent(hoverIntentConfig);
	
}

function menuOn() {
	$(this).addClass('is-active');
	$(this).find($el.subnavContent).addClass('is-active');
}

function menuOff() {
	$(this).removeClass('is-active');
	$(this).find($el.subnavContent).removeClass('is-active');
}

function open() {
	mmenuApi.open();
	$el.navToggle.addClass('is-active');
	navIsOpen = true;
	closeSearch();
}

export function close() {
	mmenuApi.close();
	$el.navToggle.removeClass('is-active');
	navIsOpen = false;
} 